const BRAND = {
  gradient: 'linear-gradient(135deg, #F97316 0%, #EC4899 50%, #8B5CF6 100%)',
  dark: '#0F0F1E',
};

export default function LoadingScreen() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: BRAND.dark, fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: 48, height: 48, borderRadius: '50%', margin: '0 auto 20px',
          border: '3px solid rgba(255,255,255,0.1)',
          borderTopColor: '#F97316',
          animation: 'spin 0.8s linear infinite',
        }} />
        <p style={{ color: '#94A3B8', fontSize: 15 }}>Loading your proposal...</p>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );
}
